import { APP_BASE_URL } from '../../env';
export const COMPANY_NAME = '合同会社Co-nnect Inc.';
export const COMPANY_ADDRESS = {
    addressCountry: 'JP',
    addressLocality: '中央区日本橋富沢町',
    addressRegion: '東京都',
    postalCode: '103-0006',
    streetAddress: '10-13 & WORK NIHONBASHI 5F',
};
export const COMPANY_LOGO = `${APP_BASE_URL}/images/footer_c.svg`;
export const COMPANY_TELEPHONE = '03-3537-7720';
export const COMPANY_GEO = {
    latitude: 35.689626,
    longitude: 139.7826292,
};
